import {
  CUE_PANEL_ROOT_MOUNT_ID,
  CUE_TRIGGER_MOUNT_ID,
} from '../../../components/WxCopilotHost/constants';

const editable =
  'textarea, select, [role="textbox"], [role="slider"], [role="listbox"]';
const nonTextInputs = [
  'checkbox',
  'radio',
  'button',
  'submit',
  'reset',
  'file',
  'range',
  'color',
  'image',
  'hidden',
];
const hosts = [CUE_PANEL_ROOT_MOUNT_ID, CUE_TRIGGER_MOUNT_ID, 'wx-navbar-root'];

export function isTypingEvent(event: KeyboardEvent): boolean {
  const path = event.composedPath();
  if (path.some(node => node instanceof Element && hosts.includes(node.id)))
    return true;
  const target = path[0];
  const input = target instanceof Element ? target.closest('input') : null;
  return (
    target instanceof Element &&
    ((target instanceof HTMLElement && target.isContentEditable) ||
      Boolean(target.closest(editable)) ||
      (input instanceof HTMLInputElement &&
        !nonTextInputs.includes(input.type)))
  );
}

export function isOtherSurfaceOpen(doc: Document): boolean {
  return Array.from(
    doc.querySelectorAll(
      '[role="dialog"], [role="alertdialog"], [aria-modal="true"], [role="menu"], [role="listbox"], body > [role="presentation"]',
    ),
  ).some(
    element =>
      element.getClientRects().length > 0 &&
      doc.defaultView?.getComputedStyle(element).visibility !== 'hidden' &&
      !element.closest('[data-splash-part="layer"], .MuiSnackbar-root'),
  );
}
